import React from 'react';
import { Link } from 'react-router-dom';
import { ZapIcon } from 'lucide-react';
export function Logo({
  inverted = false
}: {
  inverted?: boolean;
}) {
  return <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="Ampra Energy – naar de homepage" data-id="element-318" data-mp="y91xcrwomtby">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-volt" data-id="element-319" data-mp="ocqjvylcvxfx">
        <ZapIcon className="h-[18px] w-[18px] text-ink" strokeWidth={2.5} fill="currentColor" aria-hidden="true" data-id="element-320" data-mp="of2xy0nztnnp" />
      </span>
      <span className={`text-xl font-extrabold tracking-tight ${inverted ? 'text-white' : 'text-ink'}`} data-id="element-321" data-mp="fkohvvvn293j">
        ampra<span className={inverted ? 'text-volt' : 'text-muted'} data-id="element-322" data-mp="akioob9q0ejc">.</span>
      </span>
    </Link>;
}